import { selectAgent } from 'shared/selectors/selectAgent';
import { IState } from 'shared/store';

export const selectIsDeveloper = (state: IState): boolean => {
  const agent = selectAgent(state);

  return !!agent?.isDeveloper;
};
